export default class CardRowHtml {
    constructor(headline, subline, items, colSize) {
        this._headline = headline;
        this._subline = subline;
        this._items = items;
        this._colSize = colSize;

        switch (colSize) {
            case 4: this._slidesToShow = 4; break;
            default: this._slidesToShow = 3; break;
        }
    }

    _getItemHtml() {
        let itemsHtml = '';

        this._items.forEach((item) => {
            itemsHtml += `
                <div class="rfct-card-media-item col-xs-12 col-sm-6 col-md-4">
                    ${item}
                </div>
            `;
        });

        return itemsHtml;
    }

    _getHeadlineHtml() {
        return this._headline ? `<h2 class="rfct-card-slider__headline">${this._headline}</h2>` : '';
    }

    _getSublineHtml() {
        return this._subline ? `<h3 class="rfct-card-slider__subline">${this._subline}</h3>` : '';
    }

    toString() {
        return `
            <div class="rfct-card-media" data-slides-lg="${this._slidesToShow}">
                ${this._getHeadlineHtml()}
                ${this._getSublineHtml()}
                <div class="rfct-card-media-container row">
                    ${this._getItemHtml()}
                </div>
            </div>
        `;
    }
}
